<fstr-dynamic-form
  #form
  [config]="formFields"
  class="product-filters"
  [showSubmit]="false"
  (formChanges)="filtered.emit($event)"
></fstr-dynamic-form>

@if (formFields.length) {
  <button class="button button-outline button--secondary d-none d-md-inline-block" (click)="reset()">
    <span>{{ 'product-filters-reset-knoptekst' | fromDictionary }}</span>
  </button>
}
